import PersonContactCard from './PersonContactCard';

export default PersonContactCard;
